export default __webpack_public_path__ + "static/media/map-pin-location-now.8e70f7d5.svg";